import { baseBackend } from "../../../../api/base/baseUrl";

const BOOKING_CANCELLATION_URL = "/api/v2/cancellation/booking";

export async function createBookingCancellationRequest(payload) {
  const response = await baseBackend.post(BOOKING_CANCELLATION_URL, payload);
  return response.data;
}
